import { useEffect } from 'react';
import type { ExpressionCharacteristic } from '../../schema';
import { useEvaluated } from '../../eval/EvalContext';
import { useTranslation } from '../../i18n';
import { formatCalculatedValue } from './formatCalculatedValue';

/**
 * Read-only display of the evaluated formula. The expression source is
 * never rendered as user-facing text — admins author the formula in the
 * backend; customers only need the result. Source + raw value land in
 * `console.debug` for support diagnostics.
 */
export function ExpressionView({ characteristic }: { characteristic: ExpressionCharacteristic }) {
    const { locale } = useTranslation();
    const result = useEvaluated(characteristic.id);

    useEffect(() => {
        console.debug(
            '[configento] expression result',
            characteristic.altTitle || characteristic.id,
            { expression: characteristic.expression, result },
        );
    }, [characteristic.id, characteristic.altTitle, characteristic.expression, result]);

    return (
        <span className="cfg-calc-value" data-configento-eval-result>
            {formatCalculatedValue(result, characteristic.decimalPlace, locale)}
        </span>
    );
}
